__turbopack_context__.v({
  "container": "OurStoryItemsMobile-module__PJ-CWa__container",
  "icon": "OurStoryItemsMobile-module__PJ-CWa__icon",
  "item": "OurStoryItemsMobile-module__PJ-CWa__item",
  "year": "OurStoryItemsMobile-module__PJ-CWa__year",
});
